import React from 'react';
import { unixFormat } from '../../../../../helpers/times';
import { replaceHost } from '../../../../../helpers/replace-host';
import getFullname from '../../../../../helpers/get-fullname';
import getMemberNickname from '../../../../../helpers/get-member-nickname';
import { PAGES_VIEW_GRID } from '../../../../../constants/page-settings/schedule';
import { CTags } from '../../../../UI';
import PartnersBaseView from '../../../../Partners/PartnersViews/PartnersBaseView';
import MemberPhoto from '../../../../Members/MembersComponents/MemberPhoto';
import MembersSimpleView from '../../../../Members/MembersComponents/MembersSimpleView';
import { useEventContext } from '../../../../../context/EventContext';

import '../../../common-styles/card.scss';
import './style.scss';

const EpisodeCard = ({
    episode,
    $locale,
    pdfSettings,
    className = '',
    cardStyles = {},
    isGridCard = false,
    isFullInfo = false,
}) => {
    const contentRef = React.useRef(null);
    const {event} = useEventContext();
    const {moduleEpisode} = event || {};

    React.useEffect(() => {
        if (!!contentRef.current && pdfSettings.view === PAGES_VIEW_GRID) {
            const contentRect = contentRef.current.getBoundingClientRect();
            const childrens = contentRef.current.querySelectorAll('.pdf-card__content > div');
            let childensHeight = 10;

            Array.from(childrens).forEach((child, index) => {
                childensHeight += child.clientHeight;

                if (contentRect.height < childensHeight + (index * 5)) {
                    child.style.opacity = 0;
                } else {
                    child.style.opacity = 1;
                }
            });
        }
    }, [cardStyles.height]);

    return (
        <div
            className={`pdf-card pdf-card--${pdfSettings.view} ${className}`}
            data-episode={episode.id}
            style={{
                ...cardStyles,
            }}
        >
            <div className="pdf-card__hall">
                <span>
                    {$locale.getProperty(episode.stream, 'description')}
                </span>
            </div>
            <div
                ref={contentRef}
                className="pdf-card__content"
            >
                <div className="pdf-card__content-header">
                    {
                        
                    }
                    <div className={`pdf-card__content-time ${(episode.importantEpisode && episode.displayTimeLarge) ? 'pdf-card__content-time--lg' : ''}`}>
                        {unixFormat(episode.timeStart, 'HH:mm')} — {unixFormat(episode.timeStop, 'HH:mm')}
                    </div>
                    {
                        !!pdfSettings?.showFormat &&
                        <div className="pdf-card__content-format">
                            {$locale.get(`participationType.${episode.displayParticipationType}`)}
                        </div>
                    }
                    <div className={`pdf-card__content-title  ${episode.importantEpisode ? 'pdf-card__content-title--lg' : ''}`}>
                        {$locale.getProperty(episode, 'name')}
                    </div>
                </div>
                {
                    (!!episode.tags?.length && !!pdfSettings?.showTags) &&
                    <CTags tags={episode.tags} />
                }
                {
                    isFullInfo &&
                    <div className="pdf-card__content-info">
                        {$locale.getProperty(episode, 'info')}
                    </div>
                }
                {
                    (!!episode.partners?.length && !!pdfSettings?.showLogos) &&
                    <div style={{paddingTop: 10}}>
                        <PartnersBaseView
                            partners={episode.partners}
                            size="xs"
                        />
                    </div>
                }
                {
                    isGridCard || isFullInfo
                    ? (
                        (moduleEpisode?.membersEnabled && !!pdfSettings?.showMembersGroupAndName && !!episode?.groups.length) &&
                        episode?.groups.map((group) => {
                            const members = group.members.map(({member}) => {
                                if (member.hide) return;
                                if (!pdfSettings?.showMembersPhoto) return getFullname(member, $locale);

                                return (
                                    <div
                                        key={member.id}
                                        className="pdf-card__group-member"
                                    >
                                        <div className="pdf-card__group-member-photo">
                                            <MemberPhoto
                                                photo={replaceHost(member.previewUrl)}
                                                initials={getMemberNickname(member, $locale)}
                                                isPdf
                                            />
                                        </div>
                                        <span className="pdf-card__group-member-name">
                                            {getFullname(member, $locale)}
                                        </span>
                                    </div>
                                )
                            });
    
                            return (
                                <div
                                    key={group.id}
                                    className="pdf-card__group"
                                >
                                    <span className="pdf-card__group-title">
                                        {$locale.getProperty(group.role, group.members?.length > 1 ? 'groupTitle' : 'title')}:
                                    </span>
                                    <div className="pdf-card__group-members">
                                        {
                                            !pdfSettings?.showMembersPhoto
                                                ? members.join(', ')
                                                : members
                                        }
                                    </div>
                                </div>
                            )
                        })
                    )
                    : <div className="pdf-card__short-members">
                        <MembersSimpleView
                            episode={episode}
                            isPdf
                        />
                    </div>
                }
            </div>
        </div>
    )
};

export default EpisodeCard;
